import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { isDisabled } from '../utils/customPropStyles';
import Translate from './Translate';
import { NoDataForPeriodUi } from '../models/configuration/chart/PeriodSelector';
import { PeriodSelectorOptionWithDates } from './Chart';

const ChartPeriodSelectorWrapper = styled<any, any>('div')`
    ${propStyles};
`;

ChartPeriodSelectorWrapper.defaultProps = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: ['center', 'flex-start'],
    marginY: 'sm',
};

const ChartPeriodSelectorButton = styled<any, any>('button')`
    ${propStyles};
    ${isDisabled};
    outline: none;
`;

ChartPeriodSelectorButton.defaultProps = {
    cursor: 'pointer',
    fontSize: 'xs',
    fontFamily: 'body',
    fontWeight: 'normal',
    paddingX: '1em',
    paddingY: '0.5em',
    bgColor: 'gray100',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'gray300',
    margin: '0 -1px 0 0',
    selected: {
        bgColor: 'primary',
        color: 'white',
    },
    isDisabled: {
        color: 'gray500',
    },
};

interface ChartPeriodSelectorProps {
    theme?: any;
    options: Array<PeriodSelectorOptionWithDates>;
    startDate: string;
    endDate: string;
    setPeriod: (option: PeriodSelectorOptionWithDates) => void;
    noDataForPeriodUi: NoDataForPeriodUi;
}

export const ChartPeriodSelector: React.SFC<ChartPeriodSelectorProps> = ({
    theme,
    options,
    startDate,
    endDate,
    setPeriod,
    noDataForPeriodUi,
}) => (
    <ChartPeriodSelectorWrapper {...theme.ChartPeriodSelectorWrapper}>
        {options.map(option => {
            const periodHidden =
                !option.hasDataForPeriod && noDataForPeriodUi === 'hidden';

            if (periodHidden) {
                return null;
            }

            const periodDisabled =
                !option.hasDataForPeriod && noDataForPeriodUi === 'disabled';
            const periodSelected =
                option.startDate === startDate && option.endDate === endDate;

            return (
                <ChartPeriodSelectorButton
                    key={option.label}
                    disabled={periodDisabled}
                    onClick={() => setPeriod(option)}
                    {...theme.ChartPeriodSelectorButton}
                    data-selected={periodSelected && !periodDisabled}
                >
                    <Translate>{option.label}</Translate>
                </ChartPeriodSelectorButton>
            );
        })}
    </ChartPeriodSelectorWrapper>
);

export default withTheme(observer(ChartPeriodSelector));



// WEBPACK FOOTER //
// ./src/Components/ChartPeriodSelector.tsx